import { Box, styled } from '@mui/material'

export const TextButtonContainer = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))
